module.exports = __webpack_public_path__ + "static/media/sprites_2x.c0c47880.png";